import { atom } from 'jotai';

import { Company } from '@restworld/utility-types';

export const isEmployerCompanyListModalOpenAtom = atom(false);
isEmployerCompanyListModalOpenAtom.debugLabel = 'isEmployerCompanyListModalOpenAtom';

export const isEmployerCompanyActionModalOpenAtom = atom(false);
isEmployerCompanyActionModalOpenAtom.debugLabel = 'isEmployerCompanyActionModalOpenAtom';

export const selectedCompanyAtom = atom<Partial<Company>>({});
selectedCompanyAtom.debugLabel = 'selectedCompanyAtom';

type CompanyActionType = 'searchCompany' | 'createCompany' | 'editCompany';
export const currentCompanyActionAtom = atom<CompanyActionType>('searchCompany');
currentCompanyActionAtom.debugLabel = 'currentCompanyActionAtom';

export const lastCompanySearchValueAtom = atom('');
lastCompanySearchValueAtom.debugLabel = 'lastCompanySearchValueAtom';

export const newlyCreatedCompanyIdAtom = atom('');
newlyCreatedCompanyIdAtom.debugLabel = 'newlyCreatedCompanyIdAtom';
